interface Prop { 
    title: string;
  }
  
  export const SIMPLTitle = (props: Prop) => {
    const { title} = props;
  
    return (
      <div className="container mx-auto mt-10">
        <h2 className="font-['Arial'] text-5xl font-normal leading-[44px] text-left text-Foundation/Heading mt-4">
          {title}
        </h2>
      </div>
    );
  }
  